import styled from 'styled-components';

const Container = styled.div`
    height: calc(100vh - 130px);;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const ContainerTable = styled.div``;

const Footer = styled.footer``;

export {
	Container,
	ContainerTable,
	Footer,
};
